<template>
	<div class="all-wrap">
		<!-- 微信分享卡片(标题/描述/首图) -->
		<ShareMeta title="后天科技 · 项目方案" description="选择客户，查看方案、报价、作品与案例" :image="siteLogo" />

		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>
		<!-- 左侧悬浮板块导航(列表页用于预选板块) -->
		<SectionNav :active="activeTab" />

		<!-- 顶部 banner 区(站内风格:暗色大图 + 顶部导航) -->
		<div class="videolist-banner">
			<!-- 顶部导航栏 -->
			<Headernew />

			<div class="wow fadeInUp bannertop-title">
				<div>项目方案 · 客户入口</div>
				<div>——选择客户，查看方案、报价、作品；案例可直接浏览</div>
			</div>
		</div>

		<!-- ===================== 主体 ===================== -->
		<div class="app-container" ref="contentArea">
			<!-- 板块选择(最顶部,与左侧悬浮导航联动) -->
			<div class="tabs">
				<button v-for="t in tabList" :key="t.key" class="tab-btn"
					:class="{ active: activeTab === t.key }" @click="switchTab(t.key)">
					<font-awesome-icon :icon="t.icon" /> {{ t.text }}
				</button>
			</div>

			<!-- 模板入口(仅 VIP)：方案模板 / 报价模板 -->
			<div class="template-bar" v-if="isVip">
				<button class="template-btn" @click="openTemplate('scheme')">
					<font-awesome-icon icon="fa-solid fa-file-lines" /> 方案模板
				</button>
				<button class="template-btn" @click="openTemplate('budget')">
					<font-awesome-icon icon="fa-solid fa-file-invoice-dollar" /> 报价模板
				</button>
			</div>

			<!-- 方案 / 报价 / 作品：选择客户 -->
			<template v-if="!isCasesTab">
				<div class="page-head">
					<h1>
						<i class="iconfont icon-shoushimima"></i> 客户列表
					</h1>
					<button v-if="isVip" class="add-brand-btn" @click="openCreateBrand">
						<font-awesome-icon icon="fa-solid fa-plus" /> 新建客户
					</button>
				</div>

				<!-- 加载中 -->
				<LoadingBlock v-if="brandsLoading" />

				<div class="brand-grid" v-else>
					<div class="empty-state" v-if="brandList.length === 0">
						<i class="iconfont icon-dengdai"></i><p>{{ brandsError || '暂无客户' }}</p>
					</div>

					<div class="brand-card" v-for="brand in brandList" :key="brand.id"
						@click="enterBrand(brand.id)">
						<div v-if="isVip" class="brand-edit" @click.stop="openEditBrand(brand)" title="编辑客户">
							<font-awesome-icon icon="fa-solid fa-pen-to-square" />
						</div>
						<div class="brand-logo">
							<img :src="brand.logo_url" :alt="brand.name" />
						</div>
						<div class="brand-name">{{ brand.name }}</div>
						<div class="brand-go">查看{{ activeTabText }} <i class="iconfont icon-down2" style="transform:rotate(90deg);"></i></div>
					</div>
				</div>
			</template>

			<!-- 案例：直接案例列表 -->
			<template v-else>
				<div class="page-head">
					<h1>
						<i class="iconfont icon-shoushimima"></i> 案例列表
					</h1>
					<button v-if="isVip" class="add-work-btn" @click="openCreateWork">
						<font-awesome-icon icon="fa-solid fa-plus" /> 新增案例
					</button>
				</div>

				<!-- 加载中 -->
				<LoadingBlock v-if="casesLoading" />

				<div class="timeline" v-else>
					<div class="empty-state" v-if="groupedCases.length === 0">
						<i class="iconfont icon-dengdai"></i><p>{{ casesError || '暂无案例' }}</p>
					</div>

					<div class="tl-group" v-for="group in groupedCases" :key="group.date">
						<div class="tl-group-head">
							<div class="tl-marker tl-marker-date"></div>
							<div class="tl-date">{{ group.date }}</div>
						</div>
						<div class="timeline-item" v-for="item in group.items" :key="item.id" @click="toCaseDetail(item.id)">
							<div class="tl-marker"></div>
							<div class="tl-body">
								<div class="tl-card">
									<div class="tl-title">{{ item.main }}</div>
									<div class="tl-tags">
										<span v-if="item.keys_name">{{ item.keys_name }}</span>
									</div>
									<span class="tl-hint"><i class="iconfont icon-down21"></i> 查看详情</span>
									<div v-if="isVip" class="tl-toggle" :class="{ 'is-hidden': item.on_show === 0 }" @click.stop="toggleShow(item)" :title="item.on_show === 0 ? '设为可见' : '设为隐藏'">
										<font-awesome-icon :icon="item.on_show === 0 ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-del" @click.stop="removeItem(item)" title="删除">
										<font-awesome-icon icon="fa-solid fa-trash-can" />
									</div>
									<div v-if="isVip" class="tl-toggle tl-edit" @click.stop="openEditWork(item)" title="编辑">
										<font-awesome-icon icon="fa-solid fa-pen-to-square" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>

		<!-- 新建/编辑客户弹窗 -->
		<el-dialog :title="brandForm.id ? '编辑客户' : '新建客户'" :visible.sync="brandDialogVisible"
			width="440px" :close-on-click-modal="false" append-to-body custom-class="brand-dialog">
			<div class="brand-form">
				<div class="form-row">
					<label class="form-label">客户名称</label>
					<el-input v-model="brandForm.name" placeholder="请输入客户名称" maxlength="50" show-word-limit></el-input>
				</div>
				<div class="form-row">
					<label class="form-label">客户 Logo</label>
					<div class="logo-uploader" @click="pickLogo">
						<img v-if="brandForm.logo_url" :src="brandForm.logo_url" class="logo-preview" />
						<div v-else class="logo-placeholder">
							<i class="iconfont icon-add"></i><span>上传 Logo</span>
						</div>
						<div v-if="logoUploading" class="logo-loading">上传中 {{ logoUploading }}%</div>
						<input type="file" ref="logoInput" accept="image/*" @change="onLogoPicked" style="display:none" />
					</div>
				</div>
			</div>
			<span slot="footer">
				<el-button @click="brandDialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="brandSaving" @click="submitBrand">保存</el-button>
			</span>
		</el-dialog>

		<!-- 案例 新增·编辑弹窗 -->
		<el-dialog :title="workForm.id ? '编辑' : '新增'"
			:visible.sync="workDialogVisible" width="820px" :close-on-click-modal="false" append-to-body>
			<el-form label-width="92px" size="small" class="work-form">
				<el-form-item label="名称" required>
					<el-input v-model="workForm.main" placeholder="请输入名称" maxlength="80" />
				</el-form-item>
				<el-form-item label="标签">
					<el-select v-model="workForm.code_id" placeholder="请选择标签" style="width:100%">
						<!-- value 用字符串：接口返回的 tags 是字符串，严格相等才能匹配上并显示名称 -->
						<el-option v-for="t in enabledTags" :key="t.id" :label="t.name" :value="String(t.id)" />
					</el-select>
				</el-form-item>
				<el-form-item label="案例视频">
					<FileUploader v-model="workForm.open" accept="video/*" type="video" />
				</el-form-item>
				<el-form-item label="案例图片">
					<FileUploader v-model="workForm.simg" accept="image/*" type="image" />
				</el-form-item>
				<el-form-item label="案例外链">
					<el-input v-model="workForm.link_url" placeholder="http://..." />
				</el-form-item>
				<el-form-item label="案例描述">
					<el-input v-model="workForm.detail" type="textarea" :rows="3" placeholder="请输入案例描述" />
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="workDialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="workSaving" @click="submitWork">保存</el-button>
			</span>
		</el-dialog>

		<!-- 底部页脚(项目统一) -->
		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'
import SectionNav from '@/components/SectionNav.vue'
import FileUploader from '@/components/FileUploader.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import ShareMeta from '@/components/ShareMeta.vue'

export default {
	name: 'projectProposal',
	components: { Headernew, Footernew, Comment, gotop, SectionNav, FileUploader, LoadingBlock, ShareMeta },
	data() {
		return {
			// 客户列表(方案/报价/作品 Tab 用)
			brandList: [],
			brandsLoading: false,
			brandsError: '',
			casesLoading: false,
			casesError: '',
			// 案例列表(案例 Tab 直接展示,不限客户)
			casesList: [],
			casesLoaded: false,
			// 标签(全量,用于把案例的标签 ID 映射成名称)
			tagList: [],
			// 预选的板块(页面 Tab 与左侧悬浮导航联动，进入客户时带上)
			activeTab: 'scheme',
			tabList: [
				{ key: 'scheme', text: '方案', icon: 'fa-solid fa-file-lines' },
				{ key: 'budget', text: '报价', icon: 'fa-solid fa-file-invoice-dollar' },
				{ key: 'works', text: '作品', icon: 'fa-solid fa-film' },
				{ key: 'cases', text: '案例', icon: 'fa-solid fa-briefcase' },
			],

			// 新建/编辑客户弹窗
			brandDialogVisible: false,
			brandSaving: false,
			logoUploading: 0,           // 0 表示未上传，1-100 为进度
			brandForm: { id: null, name: '', logo_url: '' },

			// 模板链接（新窗口打开，仅 VIP 可见）
			templateUrls: {
				scheme: 'https://xjaikj.htkjbd.com/guanwangmuban/%E6%96%B9%E6%A1%88%E6%A8%A1%E6%9D%BF.html',
				budget: 'https://xjaikj.htkjbd.com/guanwangmuban/%E6%8A%A5%E4%BB%B7%E6%A8%A1%E6%9D%BF.html',
			},

			// 案例 新增·编辑弹窗
			workDialogVisible: false,
			workSaving: false,
			workForm: {
				id: null,
				main: '',
				brand_id: '',
				code_id: '',
				simg: '',
				link_url: '',
				pdf: '',
				style: 'case',
				open: '',
				html_url: '',
				detail: '',
			},
		}
	},
	computed: {
		// 当前预选板块的中文名(客户卡片提示用)
		activeTabText() {
			const t = this.tabList.find(t => t.key === this.activeTab)
			return t ? t.text : '方案'
		},
		// 是否案例 Tab(案例直接展示列表,不走客户列表)
		isCasesTab() { return this.activeTab === 'cases' },
		// 案例按天分组(同一天的案例归到一个日期下,日期只显示一次)
		groupedCases() { return this.groupByDate(this.casesList) },
		// 启用的标签(表单/筛选用)
		enabledTags() { return this.tagList.filter(t => t.on_show === 1) },
		// 网站图标(public/logo.png)，用作分享缩略图
		siteLogo() { return process.env.BASE_URL + 'logo.png' },
		// 是否 VIP：与 Headernew 一致，取缓存 usermessage.adminid == 1
		// 新建/编辑/删除/切换可见性 等管理操作仅 VIP 可见可操作
		isVip() {
			try {
				const m = localStorage.getItem('usermessage')
				if (!m) return false
				return JSON.parse(m).adminid == 1
			} catch (e) {
				return false
			}
		},
	},
	watch: {
		// 悬浮导航在列表页通过 ?tab= 记录预选板块
		'$route'() { this.applyRouteQuery(this.$route.query) },
	},
	created() {
		this.applyRouteQuery(this.$route.query)
	},
	mounted() {
		this.loadBrands()
		this.loadTags()
	},
	methods: {
		// 读取 URL 中的预选板块(缺省 scheme)；案例 Tab 懒加载案例列表
		applyRouteQuery(q) {
			q = q || {}
			const tabs = ['scheme', 'budget', 'works', 'cases']
			this.activeTab = tabs.indexOf(q.tab) !== -1 ? q.tab : 'scheme'
			if (this.activeTab === 'cases' && !this.casesLoaded) {
				this.loadCases()
			}
		},
		// 页面 Tab 切换(与悬浮导航联动,更新 URL 记住选择)
		switchTab(tab) {
			if (this.activeTab === tab) return
			this.$router.push({ path: '/projectProposal', query: { tab } }).catch(() => {})
		},
		// 拉取客户列表(logo + 名字)——接口分页，传 page/limit 一次拉全
		loadBrands() {
			this.brandsLoading = true
			this.brandsError = ''
			this.$axios.get(this.$api + '/getBrand', {
				params: { page: 1, limit: 1000 }
			}).then(res => {
				const body = res.data || {}
				const list = (body.result && body.result.data) || []
				this.brandList = list
				if (!body.success && !list.length) this.brandsError = body.message || ''
			}).catch(err => {
				console.log(err)
				this.brandList = []
				this.brandsError = '加载失败，请稍后重试'
			}).finally(() => { this.brandsLoading = false })
		},
		// 拉取全部案例(案例 Tab 直接展示,不限客户)
		loadCases() {
			this.casesLoaded = true
			this.casesLoading = true
			this.casesError = ''
			this.$axios.get(this.$api + '/getWorksCase', {
				params: { style: 'case', page: 1, limit: 1000 }
			}).then(res => {
				const body = res.data || {}
				const list = (body.result && body.result.data) || []
				this.casesList = list
				if (!body.success && !list.length) this.casesError = body.message || ''
			}).catch(err => {
				console.log(err)
				this.casesList = []
				this.casesError = '加载失败，请稍后重试'
			}).finally(() => { this.casesLoading = false })
		},
		// 拉取标签(全量,用于把案例的标签 ID 映射成名称)
		loadTags() {
			this.$axios.get(this.$api + '/getKeys', {
				params: { on_show: 0, page: 1, limit: 1000 }
			}).then(res => {
				this.tagList = (res.data.result && res.data.result.data) || []
			}).catch(err => console.log(err))
		},
		// 切换案例可见性(worksShow 无参自动翻转)，二次确认后刷新案例列表
		toggleShow(item) {
			// 当前非隐藏态即视为可见，点击后将被隐藏
			const willHide = item.on_show !== 0
			const tip = willHide
				? '确定将「' + (item.main || '该案例') + '」设为隐藏吗？隐藏后客户端将看不到。'
				: '确定将「' + (item.main || '该案例') + '」设为可见吗？'
			this.$confirm(tip, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				return this.$axios.post(this.$api + '/worksShow/' + item.id)
			}).then(() => {
				this.$message && this.$message.success('可见性已更新')
				this.loadCases()
			}).catch(err => {
				// 取消确认弹窗时 err 为 'cancel'/'close'，不提示错误
				if (err === 'cancel' || err === 'close') return
				console.log(err)
				this.$message && this.$message.error('操作失败')
			})
		},
		// 删除案例(deleteWorkcase/{id})，二次确认后刷新列表
		removeItem(item) {
			this.$confirm('确定删除「' + (item.main || '该案例') + '」吗？删除后不可恢复。', '删除确认', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning',
				confirmButtonClass: 'el-button--danger', // 确认按钮用危险色
			}).then(() => {
				return this.$axios.post(this.$api + '/deleteWorkcase/' + item.id)
			}).then(() => {
				this.$message && this.$message.success('已删除')
				this.loadCases()
			}).catch(err => {
				// 取消确认弹窗时 err 为 'cancel'/'close'，不提示错误
				if (err === 'cancel' || err === 'close') return
				console.log(err)
				this.$message && this.$message.error('删除失败')
			})
		},
		// 进入某客户的方案页(带上预选板块)
		enterBrand(id) {
			this.$router.push({ path: '/brandProposal', query: { brand_id: id, tab: this.activeTab } })
		},
		// 案例直接进案例详情
		toCaseDetail(id) {
			this.$router.push({ path: '/caseDetail', query: { id } })
		},

		// ---- 模板(仅 VIP)：新窗口打开，追加时间戳参数 t 防缓存 ----
		openTemplate(type) {
			let url = this.templateUrls[type]
			if (!url) return
			url += (url.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now()
			window.open(url, '_blank')
		},

		// ============ 案例 新增·编辑 ============
		// 新增：全局案例，客户需在表单里选择
		openCreateWork() {
			this.workForm = {
				id: null, main: '', brand_id: '', code_id: '', simg: '', link_url: '', pdf: '',
				style: 'case', open: '', html_url: '', detail: '',
			}
			this.workDialogVisible = true
		},
		// 编辑：回填现有记录(接口字段 → 表单字段)
		openEditWork(item) {
			this.workForm = {
				id: item.id,
				main: item.main || '',
				brand_id: item.brand_id || '',
				code_id: item.tags || '',
				simg: item.image_url || '',
				link_url: item.link_url || '',
				pdf: item.pdf_url || '',
				style: item.type === 'case' ? 'case' : 'work',
				open: item.video_url || '',
				html_url: item.html_url || '',
				detail: item.content || '',
			}
			this.workDialogVisible = true
		},
		// 保存(saveWorkcases)：带 id 改、不带 id 增(仅名称必填)
		submitWork() {
			const f = this.workForm
			if (!String(f.main || '').trim()) {
				this.$message && this.$message.warning('请输入名称')
				return
			}
			this.workSaving = true
			const payload = {
				main: f.main,
				code_id: String(f.code_id),
				simg: f.simg,
				link_url: f.link_url,
				pdf: f.pdf,
				style: f.style,
				open: f.open,
				brand_id: String(f.brand_id),
				html_url: f.html_url,
				detail: f.detail,
			}
			if (f.id) payload.id = f.id
			this.$axios.post(this.$api + '/saveWorkcases', payload).then(res => {
				const body = res.data || {}
				if (body.success || body.result) {
					this.workDialogVisible = false
					this.$message && this.$message.success(f.id ? '已保存' : '已新增')
					this.loadCases()
				} else {
					this.$message && this.$message.error(body.message || '保存失败')
				}
			}).catch(err => {
				console.log(err)
				this.$message && this.$message.error('保存失败')
			}).finally(() => { this.workSaving = false })
		},

		// ============ 新建/编辑客户 ============
		// 打开新建弹窗
		openCreateBrand() {
			this.brandForm = { id: null, name: '', logo_url: '' }
			this.logoUploading = 0
			this.brandDialogVisible = true
		},
		// 打开编辑弹窗(回填现有数据)
		openEditBrand(brand) {
			this.brandForm = { id: brand.id, name: brand.name, logo_url: brand.logo_url || '' }
			this.logoUploading = 0
			this.brandDialogVisible = true
		},
		// 触发隐藏的文件选择框
		pickLogo() {
			this.$refs.logoInput.value = ''
			this.$refs.logoInput.click()
		},
		// 选定文件后用通用上传接口传 Logo
		onLogoPicked(e) {
			const file = e.target.files && e.target.files[0]
			if (!file) return
			this.logoUploading = 1
			this.$upload(file, p => { this.logoUploading = p }).then(url => {
				this.brandForm.logo_url = url
				this.logoUploading = 0
			}).catch(err => {
				this.logoUploading = 0
				this.$message && this.$message.error(err.message || 'Logo 上传失败')
			})
		},
		// 保存客户(带 id 改、不带 id 增)
		submitBrand() {
			const name = (this.brandForm.name || '').trim()
			if (!name) {
				this.$message && this.$message.warning('请输入客户名称')
				return
			}
			this.brandSaving = true
			const payload = { name, logo_url: this.brandForm.logo_url || '' }
			if (this.brandForm.id) payload.id = this.brandForm.id
			this.$axios.post(this.$api + '/saveBrand', payload).then(res => {
				const body = res.data || {}
				if (body.success || body.result) {
					this.brandDialogVisible = false
					this.loadBrands()
					this.$message && this.$message.success(this.brandForm.id ? '已修改' : '已新建')
				} else {
					this.$message && this.$message.error(body.message || '保存失败')
				}
			}).catch(err => {
				console.log(err)
				this.$message && this.$message.error('保存失败')
			}).finally(() => { this.brandSaving = false })
		},

		// 时间轴：按 created_at 倒序后按天分组，返回 [{ date, items:[...] }]
		groupByDate(list) {
			if (!Array.isArray(list)) return []
			const t = (v) => new Date(String(v || '').replace(' ', 'T')).getTime() || 0
			const sorted = [...list].sort((a, b) => t(b.created_at) - t(a.created_at))
			const groups = []
			const map = {}
			sorted.forEach((item) => {
				const date = this.fmtDate(item.created_at)
				if (!map[date]) {
					map[date] = { date, items: [] }
					groups.push(map[date])
				}
				map[date].items.push(item)
			})
			return groups
		},
		// 日期只取年月日
		fmtDate(v) {
			if (!v) return ''
			return String(v).slice(0, 10)
		},
	},
}
</script>

<style scoped>
/* 统一盒模型，避免 width:100% + padding 导致手机端右侧溢出贴边 */
.all-wrap,
.all-wrap * {
	box-sizing: border-box;
}

/* 顶部 banner 区(站内风格) */
.videolist-banner {
	width: 100%;
	height: 700px;
	background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg);
	background-size: 100% 100%;
	position: relative;
}
.bannertop-title { width: 100%; position: absolute; left: 0; top: 30%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 61px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 35px auto 0; font-size: 31px; color: #fff; text-align: right; letter-spacing: 2px; }

/* 主体内容区 */
.app-container { max-width: 1280px; margin: 0 auto; padding: 2rem 1.5rem 4rem; }
.page-header { margin-bottom: 2rem; }
.page-header h1 { font-size: 1.75rem; font-weight: 600; color: #0a2540; display: flex; align-items: center; gap: .75rem; }
.page-header h1 i { color: #2563eb; }

/* 标题行：标题(左) + 新建客户按钮(右) */
.page-head { display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap; margin-bottom: 2rem; }
.page-head h1 { font-size: 1.75rem; font-weight: 600; color: #0a2540; display: flex; align-items: center; gap: .75rem; margin: 0; }
.page-head h1 i { color: #2563eb; }
.add-brand-btn {
	display: inline-flex; align-items: center; gap: .4rem;
	background: linear-gradient(135deg, #3b82f6, #2563eb); color: #fff;
	border: none; padding: .6rem 1.2rem; border-radius: 999px;
	font-size: .92rem; font-weight: 600; cursor: pointer;
	box-shadow: 0 4px 12px rgba(37,99,235,.3);
	transition: all .2s ease;
}
.add-brand-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(37,99,235,.42); }
.add-brand-btn svg { width: 14px; height: 14px; }
/* 新增案例按钮(与新增客户按钮同风格) */
.add-work-btn {
	display: inline-flex; align-items: center; justify-content: center; gap: .4rem;
	background: linear-gradient(135deg, #3b82f6, #2563eb); color: #fff;
	border: none; padding: .6rem 1.2rem; border-radius: 999px;
	font-size: .92rem; font-weight: 600; cursor: pointer;
	box-shadow: 0 4px 12px rgba(37,99,235,.3); transition: all .2s ease;
}
.add-work-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(37,99,235,.42); }
.add-work-btn svg { width: 14px; height: 14px; }
/* 表单弹窗 */
.work-form .el-form-item { margin-bottom: 14px; }

/* 卡片编辑角标 */
.brand-edit {
	position: absolute; top: 8px; right: 8px;
	width: 28px; height: 28px; border-radius: 8px;
	display: flex; align-items: center; justify-content: center;
	background: rgba(15,23,42,.06); color: #475569; cursor: pointer;
	opacity: 0; transition: all .2s ease;
}
.brand-edit:hover { background: #2563eb; color: #fff; }
.brand-edit svg { width: 14px; height: 14px; }
.brand-card { position: relative; }
.brand-card:hover .brand-edit { opacity: 1; }

/* 新建/编辑客户弹窗表单 */
.brand-form { display: flex; flex-direction: column; gap: 1.1rem; padding: .25rem .25rem .25rem; }
.form-row { display: flex; flex-direction: column; gap: .45rem; }
.form-label { font-size: .9rem; font-weight: 600; color: #334155; }
.logo-uploader {
	position: relative;
	width: 120px; height: 120px;
	border: 1.5px dashed #cbd5e1; border-radius: 12px;
	background: #f8fafc; cursor: pointer;
	display: flex; align-items: center; justify-content: center;
	overflow: hidden; transition: all .2s ease;
}
.logo-uploader:hover { border-color: #2563eb; background: #f0f6ff; }
.logo-preview { max-width: 90%; max-height: 90%; object-fit: contain; }
.logo-placeholder { display: flex; flex-direction: column; align-items: center; gap: .35rem; color: #94a3b8; font-size: .8rem; }
.logo-placeholder i { font-size: 1.4rem; }
.logo-loading {
	position: absolute; left: 0; right: 0; bottom: 0;
	background: rgba(15,23,42,.65); color: #fff;
	font-size: .72rem; text-align: center; padding: .2rem 0;
}

/* 板块 Tab：醒目的实心分段控件(胶囊轨道 + 蓝色实心激活) */
.tabs { display: inline-flex; gap: .5rem; background: #e8edf4; padding: .45rem; border-radius: 999px; flex-wrap: wrap; margin-bottom: 1.5rem; box-shadow: inset 0 2px 5px rgba(15,23,42,.12); }
.tab-btn { background: #fff; border: 1.5px solid #cbd5e1; padding: .8rem 1.9rem; font-size: 1.05rem; font-weight: 700; color: #475569; cursor: pointer; border-radius: 999px; transition: all .16s; display: flex; align-items: center; gap: .5rem; box-shadow: 0 2px 4px rgba(15,23,42,.08); }
.tab-btn:hover { color: #2563eb; border-color: #93c5fd; background: #f0f6ff; transform: translateY(-2px); box-shadow: 0 6px 14px rgba(37,99,235,.18); }
.tab-btn.active { color: #fff; background: linear-gradient(135deg, #3b82f6, #2563eb); border-color: #2563eb; box-shadow: 0 8px 20px rgba(37,99,235,.45), 0 0 0 3px rgba(37,99,235,.15); transform: translateY(-1px) scale(1.04); }
.tab-btn.active:hover { color: #fff; transform: translateY(-1px) scale(1.04); }

/* 模板入口(仅 VIP)：位于四个板块按钮下方，居中显示 */
.template-bar { display: flex; flex-wrap: wrap; justify-content: center; gap: .75rem; margin-bottom: 1.5rem; }
.template-btn {
	background: #fff; color: #2563eb;
	border: 1.5px solid #2563eb;
	padding: .55rem 1.3rem; border-radius: 999px;
	font-weight: 600; font-size: .9rem; cursor: pointer;
	display: inline-flex; align-items: center; gap: .4rem;
	transition: all .18s;
}
.template-btn svg { width: 14px; height: 14px; }
.template-btn:hover { background: #2563eb; color: #fff; box-shadow: 0 6px 14px rgba(37,99,235,.3); transform: translateY(-1px); }

/* 客户网格 */
.brand-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 1.25rem; }
.brand-card {
	background: #fff;
	border: 1px solid #eef2f6;
	border-radius: 14px;
	padding: 1.5rem 1rem;
	text-align: center;
	cursor: pointer;
	transition: all .2s;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: .75rem;
}
.brand-card:hover {
	border-color: #dbeafe;
	box-shadow: 0 8px 20px rgba(37, 99, 235, .12);
	transform: translateY(-4px);
}
.brand-logo {
	width: 110px;
	height: 110px;
	border-radius: 12px;
	background: #f8fafc;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.brand-logo img { max-width: 80%; max-height: 80%; object-fit: contain; }
.brand-name { font-size: 1.05rem; font-weight: 600; color: #0a2540; }
.brand-go { font-size: .8rem; color: #94a3b8; display: inline-flex; align-items: center; gap: .25rem; transition: color .2s; }
.brand-card:hover .brand-go { color: #2563eb; }
.brand-go i { font-size: .7rem; display: inline-block; }

/* ==================== 时间轴 ==================== */
.timeline { margin-top: .75rem; position: relative; }
/* 连续竖线：贯穿整条时间轴，圆点落在线上 */
.timeline::before {
	content: '';
	position: absolute;
	left: 14px;                /* marker 列(30px)的中心 */
	top: 10px;
	bottom: 10px;
	width: 2px;
	background: linear-gradient(to bottom, #bfdbfe, #cbd5e1);
	border-radius: 2px;
}
.timeline-item { position: relative; display: flex; cursor: pointer; }

/* marker 列：圆点 */
.tl-marker {
	position: relative;
	width: 30px;               /* marker 列固定宽度 */
	flex: 0 0 30px;
	display: flex;
	justify-content: center;
}
/* 圆点：渐变实心 + 白环 + 蓝色光晕，盖在竖线之上 */
.timeline-item .tl-marker::after {
	content: '';
	position: absolute;
	top: 10px;
	left: 50%;
	transform: translateX(-50%);
	width: 13px;
	height: 13px;
	background: linear-gradient(135deg, #60a5fa, #2563eb);
	border-radius: 9999px;
	border: 2px solid #fff;
	box-shadow: 0 0 0 4px rgba(37,99,235,.12), 0 2px 6px rgba(37,99,235,.35);
	z-index: 1;
	transition: box-shadow .25s ease;
}
/* 悬停整行：圆点光晕加强 */
.timeline-item:hover .tl-marker::after {
	box-shadow: 0 0 0 6px rgba(37,99,235,.18), 0 2px 8px rgba(37,99,235,.45);
}

/* 日期分组头 */
.tl-group { margin-bottom: .5rem; }
.tl-group-head { display: flex; align-items: center; margin-bottom: .5rem; }
.tl-group-head .tl-marker-date { height: 24px; }
/* 日期做成胶囊徽章 */
.tl-group-head .tl-date {
	display: inline-flex;
	align-items: center;
	margin: 0 0 0 .2rem;
	background: linear-gradient(135deg, #eff6ff, #dbeafe);
	color: #1d4ed8;
	font-size: .78rem;
	font-weight: 700;
	padding: .28rem .85rem;
	border-radius: 999px;
	letter-spacing: .4px;
	box-shadow: 0 1px 4px rgba(37,99,235,.15);
}

/* 内容列 */
.timeline-item .tl-body { flex: 1; min-width: 0; padding-bottom: 1.5rem; }
.tl-card {
	position: relative;          /* 可见性开关的定位锚点 */
	padding: 1rem 1.25rem;
	background: #fff;
	border-radius: 12px;
	border: 1px solid #eef2f6;
	border-left: 3px solid #2563eb;
	box-shadow: 0 1px 3px rgba(15,23,42,.05);
	transition: all .2s ease;
	text-align: left;
}
/* 可见性开关：悬浮卡片时右上角出现小眼睛 */
.tl-toggle {
	position: absolute; top: 8px; right: 8px;
	width: 26px; height: 26px; border-radius: 8px;
	display: flex; align-items: center; justify-content: center;
	background: rgba(15,23,42,.06); color: #64748b; cursor: pointer;
	opacity: 0; transition: all .2s ease;
}
.tl-toggle:hover { background: #2563eb; color: #fff; }
.tl-toggle svg { width: 13px; height: 13px; }
.tl-card:hover .tl-toggle { opacity: 1; }
/* 隐藏态的开关常显并带琥珀色提示 */
.tl-toggle.is-hidden { opacity: 1; color: #d97706; background: rgba(245,158,11,.12); }
/* 删除按钮：排在眼睛左侧，悬浮变红 */
.tl-del { right: 40px; }
.tl-del:hover { background: #dc2626; color: #fff; }
/* 编辑按钮：排在删除左侧(必须写在 .tl-toggle 之后，否则被其 right:8px 覆盖) */
.tl-edit { right: 72px; }
.tl-edit:hover { background: #2563eb; color: #fff; }
.tl-card:hover {
	border-color: #dbeafe;
	border-left-color: #1d4ed8;
	box-shadow: 0 10px 24px rgba(37,99,235,.12);
	transform: translateX(3px);
}
.tl-title { font-weight: 600; font-size: 1.05rem; color: #0a2540; text-align: left; transition: color .2s; }
.tl-card:hover .tl-title { color: #2563eb; }
.tl-tags { display: flex; flex-wrap: wrap; gap: .35rem; margin-top: .45rem; text-align: left; }
.tl-tags span {
	background: #f1f5f9;
	font-size: .72rem;
	font-weight: 500;
	padding: .22rem .7rem;
	border-radius: 999px;
	color: #475569;
	transition: background .2s, color .2s;
}
.tl-card:hover .tl-tags span { background: #e0ecff; color: #2563eb; }
.tl-hint {
	display: inline-flex;
	align-items: center;
	gap: .25rem;
	font-size: .75rem;
	font-weight: 500;
	color: #94a3b8;
	margin-top: .55rem;
	transition: color .2s;
}
.tl-hint i { font-size: .65rem; display: inline-block; transform: rotate(-90deg); transition: transform .2s; }
.timeline-item:hover .tl-hint { color: #2563eb; }
.timeline-item:hover .tl-hint i { transform: rotate(-90deg) translateX(2px); }

.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; grid-column: 1 / -1; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }
.empty-state p { margin: 0; }

/* 响应式 */
@media (max-width: 768px) {
	.videolist-banner { height: 380px; }
	.bannertop-title { top: 40%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	/* 手机端：Tab 改为 2×2 等分网格 */
	.tabs { display: grid; grid-template-columns: repeat(2, 1fr); gap: .45rem; width: 100%; padding: .45rem; border-radius: 14px; }
	.tab-btn { justify-content: center; padding: .7rem .5rem; font-size: .92rem; border-radius: 12px; transform: none; }
	.tab-btn.active { transform: scale(1.02); }
	.brand-grid { grid-template-columns: repeat(2, 1fr); gap: .8rem; }
	.brand-card { padding: 1rem .5rem; }
	.brand-logo { width: 84px; height: 84px; }
	.brand-name { font-size: .95rem; }
	/* 手机端无 hover：客户编辑角标常显 */
	.brand-edit { opacity: 1; }
	/* 手机端时间轴：更紧凑 */
	.tl-marker { width: 24px; flex: 0 0 24px; }
	.timeline::before { left: 11px; }   /* 对齐 24px marker 中心 */
	.timeline-item .tl-marker::after { width: 11px; height: 11px; top: 9px; }
	.tl-card { padding: .85rem 1rem; }
	.tl-title { font-size: .98rem; }
	/* 手机端无 hover：卡片操作按钮常显，排在"查看详情"后面(不再绝对定位悬浮) */
	.tl-toggle {
		position: static;
		opacity: 1;
		display: inline-flex;
		width: 30px;
		height: 30px;
		margin-left: .4rem;
		margin-top: .5rem;
		vertical-align: middle;
	}
	.tl-toggle svg { width: 14px; height: 14px; }
}
</style>

<style>
@import '../assets/css/alibaba.css';
</style>
